import { call, put } from 'redux-saga/effects';
import type { Client } from '@core/api/utils';
import { cancelDigitalSubscription } from '../api/manageSubscriptions';
import { loadSubscriptions } from '../redux/subscriptions';
import type { SubsDigCancelRequestAction } from '../redux/updates';
import { cancelDigSuccess, cancelDigFailure } from '../redux/updates';

const cancelSubscription = function* (
  client: Client,
  action: SubsDigCancelRequestAction,
) {
  try {
    const {
      sub: { id },
    } = action.payload;
    yield call(cancelDigitalSubscription, client, id);

    yield put(loadSubscriptions());
    yield put(cancelDigSuccess());
  } catch (e) {
    yield put(cancelDigFailure());
  }
};

export default cancelSubscription;
